"use client"
import Image from "next/image";
import userInfoStore from "@/store/userInfoStore";
import useMobileDetect from "@/hooks/useMobileDetect";

type UnloginProps = {
  isFirstMobile?: boolean,
}

const Unlogin: React.FC<UnloginProps> = ({ isFirstMobile }) => {
  const { userInfo } = userInfoStore();
  const isMobile = useMobileDetect(isFirstMobile);
  // 如果用户已经登录，则不显示
  return (
    userInfo?.email ?
      null
      :
      <div 
        key="unlogin" 
        className="relative w-full"
        style={{
          aspectRatio: isMobile ? '1030/300' : '4080/816',
          paddingTop: isMobile ? '29.1262%' : '20%',
        }}
      >
        <Image
          data-src={isMobile ? "/img/h5/index/unlogin.webp" : "/img/index/unlogin.webp"}
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          alt="Unlogin"
          width={100}
          height={100}
          loading='lazy'
          
          className="w-full h-full bravve_lic ant-skeleton-image-self absolute top-0 left-0"
          onClick={() => {
            document.getElementById('signInBtn')?.click()
          }}
        />
      </div>
  )
}

export default Unlogin